import {
  ColorToken,
  ShadowToken,
  CUSTOM_COLORS,
  CUSTOM_SHADOW,
} from "./src/themeConfig";
import TAILWIND_CONFIG from "./src/tailwindConfig";

declare module "@mui/material/styles" {
  interface SimplePaletteColorOptions {
    component?: string;
    section?: string;
    screen?: string;
    gradient?: string;
  }

  interface TypeText {
    support?: string;
    main?: string;
  }
  interface PaletteOptions {
    neutral?: SimplePaletteColorOptions;
    backgroundColor?: SimplePaletteColorOptions;
  }

  interface Palette {
    neutral: SimplePaletteColorOptions;
    backgroundColor: SimplePaletteColorOptions;
  }

  interface TypographyVariants {
    headingH1: React.CSSProperties;
    headingH2: React.CSSProperties;
    headingH3: React.CSSProperties;
    headingH4: React.CSSProperties;
    headingH5: React.CSSProperties;
    headingH6: React.CSSProperties;
    bodyL: React.CSSProperties;
    bodyS: React.CSSProperties;
    buttonL: React.CSSProperties;
    buttonM: React.CSSProperties;
    buttonS: React.CSSProperties;
    labelL: React.CSSProperties;
    labelS: React.CSSProperties;
    caption: React.CSSProperties;
    display_xl_r: React.CSSProperties;
    display_xl_m: React.CSSProperties;
    display_xl_sb: React.CSSProperties;
    display_lg_r: React.CSSProperties;
    display_lg_m: React.CSSProperties;
    display_lg_sb: React.CSSProperties;
    display_md_r: React.CSSProperties;
    display_md_m: React.CSSProperties;
    display_md_sb: React.CSSProperties;
    display_sm_r: React.CSSProperties;
    display_sm_m: React.CSSProperties;
    display_sm_sb: React.CSSProperties;
    display_xs_r: React.CSSProperties;
    display_xs_m: React.CSSProperties;
    display_xs_sb: React.CSSProperties;
    text_xl_r: React.CSSProperties;
    text_xl_m: React.CSSProperties;
    text_xl_sb: React.CSSProperties;
    text_lg_r: React.CSSProperties;
    text_lg_m: React.CSSProperties;
    text_lg_sb: React.CSSProperties;
    text_md_r: React.CSSProperties;
    text_md_m: React.CSSProperties;
    text_md_sb: React.CSSProperties;
    text_sm_r: React.CSSProperties;
    text_sm_m: React.CSSProperties;
    text_sm_sb: React.CSSProperties;
    text_xs_r: React.CSSProperties;
    text_xs_m: React.CSSProperties;
    text_xs_sb: React.CSSProperties;
  }

  // allow configuration using `createTheme`
  interface TypographyVariantsOptions {
    headingH1?: React.CSSProperties;
    headingH2?: React.CSSProperties;
    headingH3?: React.CSSProperties;
    headingH4?: React.CSSProperties;
    headingH5?: React.CSSProperties;
    headingH6?: React.CSSProperties;
    bodyL?: React.CSSProperties;
    bodyS?: React.CSSProperties;
    buttonL?: React.CSSProperties;
    buttonM?: React.CSSProperties;
    buttonS?: React.CSSProperties;
    labelL?: React.CSSProperties;
    labelS?: React.CSSProperties;
    caption?: React.CSSProperties;
    display_xl_r?: React.CSSProperties;
    display_xl_m?: React.CSSProperties;
    display_xl_sb?: React.CSSProperties;
    display_lg_r?: React.CSSProperties;
    display_lg_m?: React.CSSProperties;
    display_lg_sb?: React.CSSProperties;
    display_md_r?: React.CSSProperties;
    display_md_m?: React.CSSProperties;
    display_md_sb?: React.CSSProperties;
    display_sm_r?: React.CSSProperties;
    display_sm_m?: React.CSSProperties;
    display_sm_sb?: React.CSSProperties;
    display_xs_r?: React.CSSProperties;
    display_xs_m?: React.CSSProperties;
    display_xs_sb?: React.CSSProperties;
    text_xl_r?: React.CSSProperties;
    text_xl_m?: React.CSSProperties;
    text_xl_sb?: React.CSSProperties;
    text_lg_r?: React.CSSProperties;
    text_lg_m?: React.CSSProperties;
    text_lg_sb?: React.CSSProperties;
    text_md_r?: React.CSSProperties;
    text_md_m?: React.CSSProperties;
    text_md_sb?: React.CSSProperties;
    text_sm_r?: React.CSSProperties;
    text_sm_m?: React.CSSProperties;
    text_sm_sb?: React.CSSProperties;
    text_xs_r?: React.CSSProperties;
    text_xs_m?: React.CSSProperties;
    text_xs_sb?: React.CSSProperties;
  }
}

declare module "@mui/material/Paper" {
  interface PaperPropsVariantOverrides {
    rmh: true;
  }
}

// Update the Typography's variant prop options
declare module "@mui/material/Typography" {
  interface TypographyPropsVariantOverrides {
    headingH1: true;
    headingH2: true;
    headingH3: true;
    headingH4: true;
    headingH5: true;
    headingH6: true;
    bodyL: true;
    bodyS: true;
    buttonL: true;
    buttonM: true;
    buttonS: true;
    labelL: true;
    labelS: true;
    caption: true;
    display_xl_r: true;
    display_xl_m: true;
    display_xl_sb: true;
    display_lg_r: true;
    display_lg_m: true;
    display_lg_sb: true;
    display_md_r: true;
    display_md_m: true;
    display_md_sb: true;
    display_sm_r: true;
    display_sm_m: true;
    display_sm_sb: true;
    display_xs_r: true;
    display_xs_m: true;
    display_xs_sb: true;
    text_xl_r: true;
    text_xl_m: true;
    text_xl_sb: true;
    text_lg_r: true;
    text_lg_m: true;
    text_lg_sb: true;
    text_md_r: true;
    text_md_m: true;
    text_md_sb: true;
    text_sm_r: true;
    text_sm_m: true;
    text_sm_sb: true;
    text_xs_r: true;
    text_xs_m: true;
    text_xs_sb: true;
  }
}

export {
  ColorToken,
  ShadowToken,
  CUSTOM_COLORS,
  CUSTOM_SHADOW,
  TAILWIND_CONFIG,
};
